'use client'

import { DESKTOP } from '@/src/constants'
import { DeviceType } from '@/src/types'
import dynamic from 'next/dynamic'

const NewVisaDetailsContainerDesktop = dynamic(
    () =>
        import(
            /* webpackChunkName: "newVisaDetailsContainerDesktop" */ '@/src/container/desktop/newVisaPageContainer'
        ),
    {
        ssr: true
    }
)

const NewVisaDetailsContainerMobile = dynamic(
    () =>
        import(
            /* webpackChunkName: "newVisaDetailsContainerMobile" */ '@/src/container/mobile/newVisaPageContainer'
        ),
    {
        ssr: true
    }
)

const NewVisaPageContainer: React.FC<{
    deviceType: DeviceType
    initialStep: number
}> = ({ deviceType, initialStep }) => {
    return (
        <>
            {deviceType === DESKTOP ? (
                <NewVisaDetailsContainerDesktop initialStep={initialStep} />
            ) : (
                <NewVisaDetailsContainerMobile initialStep={initialStep} />
            )}
        </>
    )
}

export default NewVisaPageContainer